import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      d: "M6.708 4.897c.658 0 1.265.357 1.585.933l.735 1.324a2 2 0 0 1 .04 1.865l-.943 1.886s.342 1.755 1.771 3.185c1.43 1.429 3.179 1.764 3.179 1.764l1.885-.942a2 2 0 0 1 1.866.04l1.33.74c.576.32.932.927.932 1.585 0 2.342-2.182 4.031-4.356 3.158-2.31-.929-5.056-2.323-6.957-4.224-1.902-1.902-3.296-4.648-4.225-6.958-.873-2.173.816-4.356 3.158-4.356Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m17.5 3 4 4-4 4M13.5 7.004h8"
    }, null, -1)
  ])))
}
export default { render: render }